<template>
  <div class="app-container">
    <div class="title-row"><span class="title">{{ this.$route.meta.title }}</span></div>
    <el-form :model="queryParams" ref="qxcForm" size="small" :inline="true" v-show="showSearch" label-width="68px">
      <el-form-item label="起始期数">
        <el-input v-model="queryParams.startPeriod" placeholder="开始期数" clearable style="width: 100px;"/>
        -
        <el-input v-model="queryParams.endPeriod" placeholder="结束期数" clearable style="width: 100px;"/>
      </el-form-item>
      <el-form-item label="红球1" prop="redOne">
        <el-input v-model="queryParams.redOne" placeholder="红球1" clearable style="width: 80px;"/>
      </el-form-item>
      <el-form-item label="红球2" prop="redTwo">
        <el-input v-model="queryParams.redTwo" placeholder="红球2" clearable style="width: 80px;"/>
      </el-form-item>
      <el-form-item label="红球3" prop="redThree">
        <el-input v-model="queryParams.redThree" placeholder="红球3" clearable style="width: 80px;"/>
      </el-form-item>
      <el-form-item label="红球4" prop="redFour">
        <el-input v-model="queryParams.redFour" placeholder="红球4" clearable style="width: 80px;"/>
      </el-form-item>
      <el-form-item label="红球5" prop="redFive">
        <el-input v-model="queryParams.redFive" placeholder="红球5" clearable style="width: 80px;"/>
      </el-form-item>
      <el-form-item label="红球6" prop="redSix">
        <el-input v-model="queryParams.redSix" placeholder="红球6" clearable style="width: 80px;"/>
      </el-form-item>
      <el-form-item label="蓝球" prop="blueOne">
        <el-input v-model="queryParams.blueOne" placeholder="蓝球" clearable style="width: 80px;"/>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="el-icon-search" size="mini" @click="handleQueryQxc">搜索</el-button>
        <el-button icon="el-icon-refresh" size="mini" @click="resetQueryQxc">重置</el-button>
      </el-form-item>
    </el-form>
    <el-row :gutter="10" class="mb8">
      <el-col :span="1.5">
        <el-button v-hasPermi="['lottery:qxc:init']" type="primary" plain icon="el-icon-refresh-right" size="mini" @click="handleInitAllQxc">全部初始化
        </el-button>
      </el-col>
      <el-col :span="1.5">
        <el-button v-hasPermi="['lottery:qxc:fill']" type="primary" plain icon="el-icon-refresh-right" size="mini" @click="handleFillQxcHistory">
          补全历史数据
        </el-button>
      </el-col>
      <el-col :span="1.5">
        <el-button v-hasPermi="['lottery:qxc:export']" type="warning" plain icon="el-icon-export" size="mini" @click="handleExportQxc">导出</el-button>
      </el-col>
      <el-col :span="1.5">
        <el-button v-hasPermi="['lottery:qxc:initC']" type="success" plain icon="el-icon-refresh-left" size="mini" @click="handleInitAllQxcC">
          初始化统计数据
        </el-button>
      </el-col>
      <el-col :span="1.5">
        <el-button v-hasPermi="['lottery:qxc:exportC']" type="warning" plain icon="el-icon-export" size="mini" @click="handleOpenC()">导出统计数据
        </el-button>
      </el-col>
      <el-col :span="1.5">
        <el-button v-hasPermi="['lottery:qxc:cache']" type="danger" plain icon="el-icon-export" size="mini" @click="handleRefreshQxc">刷新缓存</el-button>
      </el-col>
      <el-col :span="1.5">
        <el-button v-hasPermi="['lottery:qxc:gen']" type="success" plain icon="el-icon-refresh-left" size="mini" @click="handleOpenGenerateQxc">
          生成七星彩
        </el-button>
      </el-col>
      <el-col :span="1.5">
        <el-button v-hasPermi="['lottery:qxc:exportF']" type="warning" plain icon="el-icon-export" size="mini" @click="exportFrequency">导出组合频率
        </el-button>
      </el-col>
      <right-toolbar :show-search.sync="showSearch" @queryTable="getQxcList" />
    </el-row>
    <el-table :data="qxcList" v-loading="loading" border highlight-current-row
              :cell-class-name="cellClassName">
      <el-table-column label="期号" align="center" prop="period"/>
      <el-table-column label="红球号码" align="center">
        <el-table-column label="1" align="center" prop="redOne"/>
        <el-table-column label="2" align="center" prop="redTwo"/>
        <el-table-column label="3" align="center" prop="redThree"/>
        <el-table-column label="4" align="center" prop="redFour"/>
        <el-table-column label="5" align="center" prop="redFive"/>
        <el-table-column label="6" align="center" prop="redSix"/>
      </el-table-column>
      <el-table-column label="蓝球" align="center" prop="blueOne"/>
      <el-table-column label="奖池金额" align="right" prop="pondAmount" min-width="100px">
        <template slot-scope="scope">
          {{ formatYuan(scope.row.pondAmount) }}
        </template>
      </el-table-column>
      <el-table-column label="一等奖" align="center">
        <el-table-column label="注数" align="center" prop="firstCount"/>
        <el-table-column label="奖金(元)" align="right" prop="firstAmount" min-width="90px">
          <template slot-scope="scope">
            {{ formatYuan(scope.row.firstAmount) }}
          </template>
        </el-table-column>
      </el-table-column>
      <el-table-column label="二等奖" align="center">
        <el-table-column label="注数" align="center" prop="secondCount"/>
        <el-table-column label="奖金(元)" align="right" prop="secondAmount">
          <template slot-scope="scope">
            {{ formatYuan(scope.row.secondAmount) }}
          </template>
        </el-table-column>
      </el-table-column>
      <el-table-column label="销售金额" align="right" prop="saleAmount" min-width="100px">
        <template slot-scope="scope">
          {{ formatYuan(scope.row.saleAmount) }}
        </template>
      </el-table-column>
      <el-table-column label="开奖日期" align="center" prop="lotteryDate" width="100">
        <template slot-scope="scope">
          {{ scope.row.lotteryDate | date }}
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" width="300px">
        <template slot-scope="scope">
          <el-button v-hasPermi="['lottery:qxc:win']" type="text" icon="el-icon-data-analysis" @click="handleWinning(scope.row)">概率</el-button>
          <el-button v-hasPermi="['lottery:qxc:next']" type="text" icon="el-icon-medal" @click="handleNextHistory(scope.row.period)">下期历史</el-button>
          <el-button v-hasPermi="['lottery:qxc:nextF']" type="text" icon="el-icon-medal" @click="handleNextNum(scope.row.period)">下期频率</el-button>
        </template>
      </el-table-column>
    </el-table>
    <pagination
      v-show="total>0"
      :total="total"
      :page.sync="queryParams.current"
      :limit.sync="queryParams.size"
      @pagination="getQxcList"
      :page-sizes="[10, 20, 30, 50, 100, 200]"
    />
    <!-- 导出统计次数弹出层 -->
    <el-dialog :title="cTitle" :visible.sync="cOpen" width="300px" :close-on-click-modal="false">
      <el-form ref="cForm" :model="cForm" :rules="cRules" label-width="110px" label-suffix="：">
        <el-form-item prop="isC">
                    <span slot="label">
                      是否排序
                      <el-popover
                        placement="top-start"
                        width="250"
                        trigger="hover"
                        content="如果排序为是，导出数据号码为历史出现次数从多到少的顺序;否则按照数据号码从小到大排序">
                        <i slot="reference" class="el-icon-question"></i>
                      </el-popover>
                    </span>
          <el-select v-model="cForm.isC" placeholder="请选择是否" style="width: 140px">
            <el-option :key="true" label="是" :value="true"></el-option>
            <el-option :key="false" label="否" :value="false"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="exportC">导出</el-button>
        <el-button @click="cancelC">取消</el-button>
      </div>
    </el-dialog>
    <!-- 生成七星彩弹出层 -->
    <el-dialog title="生成七星彩" :visible.sync="generateQxcOpen" width="750px" :close-on-click-modal="false">
      <el-form ref="generateQxcForm" :model="generateQxcForm" :inline="true" :rules="generateQxcRules"
               label-width="80px">
        <el-form-item label="生成个数" prop="count">
          <el-select v-model="generateQxcForm.count" placeholder="请选择个数">
            <el-option :key="1" label="1" :value="1"/>
            <el-option :key="5" label="5" :value="5"/>
            <el-option :key="10" label="10" :value="10"/>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" size="mini" @click="handleGenerateQxc">生成</el-button>
          <el-button icon="el-icon-refresh" size="mini" @click="resetGenerateQxc">重置</el-button>
        </el-form-item>
      </el-form>
      <el-table :data="generateQxcList" border style="width: 100%" :cell-class-name="cellClassName"
                highlight-current-row>
        <el-table-column label="红球号码" align="center">
          <el-table-column label="1" align="center" prop="redOne"/>
          <el-table-column label="2" align="center" prop="redTwo"/>
          <el-table-column label="3" align="center" prop="redThree"/>
          <el-table-column label="4" align="center" prop="redFour"/>
          <el-table-column label="5" align="center" prop="redFive"/>
          <el-table-column label="6" align="center" prop="redSix"/>
        </el-table-column>
        <el-table-column label="蓝球" align="center" prop="blueOne"/>
        <el-table-column label="操作" align="center">
          <template slot-scope="scope">
            <el-button v-hasPermi="['lottery:qxc:win']" type="text" icon="el-icon-data-analysis" @click="handleWinning(scope.row)">概率</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="close">关闭</el-button>
      </div>
    </el-dialog>
    <!-- 往期中奖概率弹出层 -->
    <el-dialog title="往期中奖概率" :visible.sync="winningOpen" width="500px">
      <el-row :gutter="20" v-for="(item,index) in winningList" :key="index" style="padding: 5px 0">
        <el-col :span="8">{{ item.name }}</el-col>
        <el-col :span="8">注数：{{ item.count }}</el-col>
        <el-col :span="8">概率：{{ formatMoney(item.winningRate * 100, 2) }}%</el-col>
      </el-row>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="winningOpen=false">关 闭</el-button>
      </div>
    </el-dialog>
    <!-- 下期七星彩同期历史数据弹出层 -->
    <el-dialog :title="qxcHistoryTitle" :visible.sync="qxcHistoryOpen" width="900px" :close-on-click-modal="false">
      <el-tabs v-model="activeQxcHistoryName" type="border-card">
        <el-tab-pane label="历史同期数据" name="firstQxc">
          <el-table :data="qxcHistoryList" border style="width: 100%" :cell-class-name="cellClassName"
                    highlight-current-row>
            <el-table-column label="期数" align="center" prop="period" width="70"/>
            <el-table-column label="红球号码" align="center">
              <el-table-column label="1" align="center" prop="redOne" width="60"/>
              <el-table-column label="2" align="center" prop="redTwo" width="60"/>
              <el-table-column label="3" align="center" prop="redThree" width="60"/>
              <el-table-column label="4" align="center" prop="redFour" width="60"/>
              <el-table-column label="5" align="center" prop="redFive" width="60"/>
              <el-table-column label="6" align="center" prop="redSix" width="60"/>
            </el-table-column>
            <el-table-column label="蓝球" align="center" prop="blueOne" width="60"/>
            <el-table-column label="和值" align="center">
              <el-table-column label="红球" align="center" prop="redSum" width="60"/>
              <el-table-column label="总和" align="center" prop="totalSum" width="60"/>
            </el-table-column>
            <el-table-column label="红球跨度" align="center" prop="redSpan" width="70"/>
            <el-table-column label="红球奇数" align="center" prop="redOdd" width="70"/>
            <el-table-column label="红球偶数" align="center" prop="redEven" width="70"/>
          </el-table>
        </el-tab-pane>
        <el-tab-pane label="统计数据" name="secondQxc">
          <el-row :gutter="10">
            <el-col :span="4" style="text-align: right">红球1次数排名：</el-col>
            <el-col :span="20">
              <el-row :gutter="10">
                <el-col v-for="(item,index) in qxcHistoryRedOneList" :key="item.num" :span="4"><span
                  style="font-weight: bold">{{ index + 1 }}.</span> <span style="color: #d73a49">{{ item.num }}</span>
                  ({{ item.counts }}次)
                </el-col>
              </el-row>
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <el-col :span="4" style="text-align: right">红球2次数排名：</el-col>
            <el-col :span="20">
              <el-row :gutter="10">
                <el-col v-for="(item,index) in qxcHistoryRedTwoList" :key="item.num" :span="4"><span
                  style="font-weight: bold">{{ index + 1 }}.</span> <span style="color: #d73a49">{{ item.num }}</span>
                  ({{ item.counts }}次)
                </el-col>
              </el-row>
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <el-col :span="4" style="text-align: right">红球3次数排名：</el-col>
            <el-col :span="20">
              <el-row :gutter="10">
                <el-col v-for="(item,index) in qxcHistoryRedThreeList" :key="item.num" :span="4"><span
                  style="font-weight: bold">{{ index + 1 }}.</span> <span style="color: #d73a49">{{ item.num }}</span>
                  ({{ item.counts }}次)
                </el-col>
              </el-row>
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <el-col :span="4" style="text-align: right">红球4次数排名：</el-col>
            <el-col :span="20">
              <el-row :gutter="10">
                <el-col v-for="(item,index) in qxcHistoryRedFourList" :key="item.num" :span="4"><span
                  style="font-weight: bold">{{ index + 1 }}.</span> <span style="color: #d73a49">{{ item.num }}</span>
                  ({{ item.counts }}次)
                </el-col>
              </el-row>
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <el-col :span="4" style="text-align: right">红球5次数排名：</el-col>
            <el-col :span="20">
              <el-row :gutter="10">
                <el-col v-for="(item,index) in qxcHistoryRedFiveList" :key="item.num" :span="4"><span
                  style="font-weight: bold">{{ index + 1 }}.</span> <span style="color: #d73a49">{{ item.num }}</span>
                  ({{ item.counts }}次)
                </el-col>
              </el-row>
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <el-col :span="4" style="text-align: right">红球6次数排名：</el-col>
            <el-col :span="20">
              <el-row :gutter="10">
                <el-col v-for="(item,index) in qxcHistoryRedSixList" :key="item.num" :span="4"><span
                  style="font-weight: bold">{{ index + 1 }}.</span> <span style="color: #d73a49">{{ item.num }}</span>
                  ({{ item.counts }}次)
                </el-col>
              </el-row>
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <el-col :span="4" style="text-align: right">蓝球次数排名：</el-col>
            <el-col :span="20">
              <el-row :gutter="10">
                <el-col v-for="(item,index) in qxcHistoryBlueList" :key="item.num" :span="4"><span
                  style="font-weight: bold">{{ index + 1 }}.</span> <span style="color: #0000FF">{{ item.num }}</span>
                  ({{ item.counts }}次)
                </el-col>
              </el-row>
            </el-col>
          </el-row>
        </el-tab-pane>
      </el-tabs>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="qxcHistoryOpen=false">关闭</el-button>
      </div>
    </el-dialog>

    <!-- 下期七星彩号码频率数据弹出层 -->
    <el-dialog :title="qxcNextNumTitle" :visible.sync="qxcNextNumOpen" width="1200px" :close-on-click-modal="false">
      <el-tabs v-model="activeQxcNextName" type="border-card">
        <el-tab-pane label="全部数字" name="allQxc">
          <el-row :gutter="10">
            <el-col :span="2" style="text-align: right">红球-红球：</el-col>
            <el-col :span="22">
              <el-row v-for="item in redRedList" :key="item.num" :gutter="10">
                <el-col :span="1" style="color: #d73a49;font-weight: bold">{{ item.num }}：</el-col>
                <el-col :span="23">
                  <el-row :gutter="10" style="margin-bottom: 10px">
                    <el-col v-for="(subItem,index) in item.numDataList" :key="subItem.num" :span="3"><span
                      style="font-weight: bold">{{ index + 1 }}.</span> <span
                      style="color: #d73a49">{{ subItem.num }}</span> ({{ subItem.counts }}次)
                    </el-col>
                  </el-row>
                </el-col>
              </el-row>
            </el-col>
          </el-row>
          <el-divider/>
          <el-row :gutter="10">
            <el-col :span="2" style="text-align: right">红球-蓝球：</el-col>
            <el-col :span="22">
              <el-row v-for="item in redBlueList" :key="item.num" :gutter="10">
                <el-col :span="1" style="color: #d73a49;font-weight: bold">{{ item.num }}：</el-col>
                <el-col :span="23">
                  <el-row :gutter="10" style="margin-bottom: 10px">
                    <el-col v-for="(subItem,index) in item.numDataList" :key="subItem.num" :span="3"><span
                      style="font-weight: bold">{{ index + 1 }}.</span> <span
                      style="color: #0000FF">{{ subItem.num }}</span> ({{ subItem.counts }}次)
                    </el-col>
                  </el-row>
                </el-col>
              </el-row>
            </el-col>
          </el-row>
          <el-divider/>
          <el-row :gutter="10">
            <el-col :span="2" style="text-align: right">蓝球-红球：</el-col>
            <el-col :span="22">
              <el-row v-for="item in blueRedList" :key="index" :gutter="10">
                <el-col :span="1" style="color: #0000FF;font-weight: bold">{{ item.num }}：</el-col>
                <el-col :span="23">
                  <el-row :gutter="10" style="margin-bottom: 10px">
                    <el-col v-for="(subItem,index) in item.numDataList" :key="index" :span="3"><span
                      style="font-weight: bold">{{ index + 1 }}.</span> <span
                      style="color: #d73a49">{{ subItem.num }}</span> ({{ subItem.counts }}次)
                    </el-col>
                  </el-row>
                </el-col>
              </el-row>
            </el-col>
          </el-row>
          <el-divider/>
          <el-row :gutter="10">
            <el-col :span="2" style="text-align: right">蓝球-蓝球：</el-col>
            <el-col :span="22">
              <el-row v-for="item in blueBlueList" :key="item.num" :gutter="10">
                <el-col :span="1" style="color: #0000FF;font-weight: bold">{{ item.num }}：</el-col>
                <el-col :span="23">
                  <el-row :gutter="10" style="margin-bottom: 10px">
                    <el-col v-for="(subItem,index) in item.numDataList" :key="subItem.num" :span="3"><span
                      style="font-weight: bold">{{ index + 1 }}.</span> <span
                      style="color: #0000FF">{{ subItem.num }}</span> ({{ subItem.counts }}次)
                    </el-col>
                  </el-row>
                </el-col>
              </el-row>
            </el-col>
          </el-row>
        </el-tab-pane>
        <el-tab-pane label="同位数字" name="digitQxc">
          <el-row v-for="item in digitList" :key="item.num" :gutter="10">
            <el-col :span="1" style="color: #d73a49;font-weight: bold">{{ item.num }}：</el-col>
            <el-col :span="23">
              <el-row :gutter="10" style="margin-bottom: 10px">
                <el-col v-for="(subItem,index) in item.numDataList" :key="subItem.num" :span="3">
                  <span style="font-weight: bold;color: #d73a49" v-if="subItem.match">{{ index + 1 }}.</span><span
                  style="font-weight: bold" v-else>{{ index + 1 }}.</span>
                  <span style="color: #d73a49" v-if="subItem.match">{{ subItem.num }}</span><span
                  v-else>{{ subItem.num }}</span>
                  <span style="color: #d73a49" v-if="subItem.match">({{ subItem.counts }}次)</span> <span
                  v-else>({{ subItem.counts }}次)</span>
                </el-col>
              </el-row>
            </el-col>
          </el-row>
        </el-tab-pane>
      </el-tabs>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="qxcNextNumOpen=false">关闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {listQxc, initAllQxc, fillHistoryData, initAllQxcC, refreshQxcCache, generateQxc, getQxcWinningData, getNextQxcHistory, getNextQxcNum } from '@/api/lottery/qxc'

export default {
  data() {
    return {
      // 遮罩层
      loading: '',
      showSearch:true,
      //七星彩数据
      qxcList: [],
      // 七星彩数量
      total: 0,
      // 查询参数
      queryParams: {
        current: 1,
        size: 10,
        startPeriod: null,
        endPeriod: null,
        redOne: null,
        redTwo: null,
        redThree: null,
        redFour: null,
        redFive: null,
        redSix: null,
        blueOne: null
      },
      cTitle: '',
      cOpen: false,
      cForm: {},
      cRules: {
        isC: [
          {required: true, message: '是否不能为空', trigger: 'blur'}
        ]
      },
      generateQxcOpen: false,
      generateQxcForm: {
        count: 1
      },
      generateQxcRules: {
        count: [
          {required: true, message: '个数不能为空', trigger: 'blur'}
        ]
      },
      generateQxcList: [],
      winningList: [],
      winningOpen: false,

      activeQxcHistoryName: 'firstQxc',
      qxcHistoryOpen: false,
      qxcHistoryTitle: '',
      qxcHistoryList: [],
      qxcHistoryRedOneList: [],
      qxcHistoryRedTwoList: [],
      qxcHistoryRedThreeList: [],
      qxcHistoryRedFourList: [],
      qxcHistoryRedFiveList: [],
      qxcHistoryRedSixList: [],
      qxcHistoryBlueList: [],

      activeQxcNextName: 'allQxc',
      qxcNextNumOpen: false,
      qxcNextNumTitle: '',
      redRedList: [],
      redBlueList: [],
      blueRedList: [],
      blueBlueList: [],
      digitList: [],
    }
  },
  created() {
    this.getQxcList()
  },
  methods: {
    cellClassName({row, column, rowIndex, columnIndex}) {
      if (column.property) {
        if (column.property === 'redOne' || column.property === 'redTwo' || column.property === 'redThree' || column.property === 'redFour' || column.property === 'redFive' || column.property === 'redSix') {
          return 'red-ball';
        } else if (column.property === 'blueOne') {
          return 'blue-ball';
        }
      }
    },
    /** 查询七星彩列表 */
    getQxcList() {
      listQxc(this.queryParams).then(res => {
        this.qxcList = res.rows;
        this.total = res.total
      })
    },
    /** 搜索七星彩列表 **/
    handleQueryQxc() {
      this.queryParams.current = 1;
      this.getQxcList()
    },
    /** 重置七星彩按钮操作 */
    resetQueryQxc() {
      this.queryParams.startPeriod = undefined;
      this.queryParams.endPeriod = undefined;

      this.resetForm("qxcForm");
      this.handleQueryQxc();
    },
    /** 初始化七星彩数据 **/
    handleInitAllQxc() {
      this.$modal.confirm("确定要初始化全部七星彩数据吗？确认后将全部重新生成！").then(action => {
        if (action === 'confirm') {
          this.$modal.loading("正在初始化中，请稍后...")
          initAllQxc().then(res => {
            this.$modal.closeLoading()
            this.$modal.msgSuccess("初始化成功")
            this.handleQueryQxc();
          }).catch(()=>{
            this.$modal.closeLoading()
          })
        }
      }).catch(()=> {})
    },
    /** 补全七星彩历史数据 **/
    handleFillQxcHistory() {
      this.$modal.confirm("确定要补全七星彩历史数据吗？").then(action => {
        if (action === 'confirm') {
          this.$modal.loading("正在补全中，请稍后...")
          fillHistoryData().then(res => {
            this.$modal.closeLoading()
            this.$modal.msgSuccess("补全成功")
            this.handleQueryQxc();
          }).catch(()=>{
            this.$modal.closeLoading()
          })
        }
      }).catch(()=> {})
    },

    /** 导出大七星彩按钮操作 */
    handleExportQxc() {
      this.download('/admin/lottery/qxc/export', {
        ...this.queryParams
      }, `七星彩导出_${new Date().getTime()}.xlsx`)
    },

    /** 初始化七星彩统计数据 **/
    handleInitAllQxcC() {
      this.$modal.confirm("确定要初始化七星彩统计数据吗？").then(action => {
        if(action === 'confirm'){
          this.$modal.loading("正在初始化中，请稍后...")
          initAllQxcC().then(res => {
            this.$modal.closeLoading()
            this.$modal.msgSuccess("初始化成功")
            this.handleQueryQxc();
          }).catch(()=>{
            this.$modal.closeLoading()
          })
        }
      }).catch(()=>{ })
    },
    /** 刷新七星彩缓存 **/
    handleRefreshQxc() {
      refreshQxcCache().then(() => {
        this.$modal.msgSuccess("刷新成功");
      })
    },
    /** 打开生成七星彩弹窗 */
    handleOpenGenerateQxc() {
      this.generateQxcOpen = true;
      this.$set(this.generateQxcForm, 'count', 1)
      this.resetForm("generateQxcForm");
      this.generateQxcList = []
    },
    handleGenerateQxc() {
      this.$refs["generateQxcForm"].validate(valid => {
        if (valid) {
          generateQxc(this.generateQxcForm).then(res => {
            if (res.flag) {
              this.generateQxcList = res.data
            }
          })
        }
      })
    },
    resetGenerateQxc() {
      this.generateQxcList = []
      this.$set(this.generateQxcForm, 'count', 1)
      this.resetForm("generateQxcForm");
    },
    /** 获奖概率弹窗 **/
    handleWinning(row) {
      this.winningList = [];
      let queryParams = {
        redOne: row.redOne,
        redTwo: row.redTwo,
        redThree: row.redThree,
        redFour: row.redFour,
        redFive: row.redFive,
        redSix: row.redSix,
        blueOne: row.blueOne,
        period: row.period
      }
      getQxcWinningData(queryParams).then(res => {
        this.winningList = res.data
        this.winningOpen = true;
      })
    },
    /** 下期历史同期数据 **/
    handleNextHistory(period) {
      this.qxcHistoryList = [];
      this.qxcHistoryRedOneList = [];
      this.qxcHistoryRedTwoList = [];
      this.qxcHistoryRedThreeList = [];
      this.qxcHistoryRedFourList = [];
      this.qxcHistoryRedFiveList = [];
      this.qxcHistoryRedSixList = [];
      this.qxcHistoryBlueList = [];
      getNextQxcHistory(period).then(res => {
        this.qxcHistoryList = res.data.lotteryDataList;
        this.qxcHistoryRedOneList = res.data.redOneList;
        this.qxcHistoryRedTwoList = res.data.redTwoList;
        this.qxcHistoryRedThreeList = res.data.redThreeList;
        this.qxcHistoryRedFourList = res.data.redFourList;
        this.qxcHistoryRedFiveList = res.data.redFiveList;
        this.qxcHistoryRedSixList = res.data.redSixList;
        this.qxcHistoryBlueList = res.data.blueList;
        this.qxcHistoryTitle = "【" + res.data.period + "】期七星彩历史同期统计";
        this.qxcHistoryOpen = true;
      })
    },
    /** 打开导出彩票统计次数弹窗 **/
    handleOpenC() {
      this.cOpen = true;
      this.cTitle = "七星彩统计数据导出";
    },
    /** 导出统计次数 **/
    exportC() {
      this.$refs["cForm"].validate(valid => {
        if (valid) {
          this.download('/admin/lottery/qxc/exportC', {
            ...this.cForm
          }, `七星彩统计数据导出_${new Date().getTime()}.xlsx`)
        }
      });
    },
    cancelC() {
      this.cOpen = false;
      this.cForm = {};
      this.resetForm("cForm");
    },
    close() {
      this.generateQxcOpen = false;
    },
    exportFrequency() {
      this.download('/admin/lottery/qxc/exportFrequency', {
        ...this.queryParams
      }, `七星彩数字组合频率导出_${new Date().getTime()}.xlsx`)
    },
    handleNextNum(period) {
      this.redRedList = [];
      this.redBlueList = [];
      this.blueRedList = [];
      this.blueBlueList = [];
      this.digitList = [];
      getNextQxcNum(period).then(res => {
        this.redRedList = res.data.redRedList;
        this.redBlueList = res.data.redBlueList;
        this.blueRedList = res.data.blueRedList;
        this.blueBlueList = res.data.blueBlueList;
        this.digitList = res.digitList;
        this.qxcNextNumTitle = "【" + period + "】下期七星彩号码频率";
        this.qxcNextNumOpen = true;
      })
    }
  }
}
</script>

